import image from "../image/p1.webp";
import image2 from "../image/p2.webp";
import image3 from "../image/p3.webp";
import image4 from "../image/p4.webp";
import image5 from "../image/p5.webp";
import image6 from "../image/p6.webp";
import image7 from "../image/p7.webp"
import image8 from "../image/p10.jpg"
import image9 from "../image/p9.jpg";
import image10 from "../image/p11.jpg";
import image11 from "../image/p12.jpg";
const HomeProducts = [
    {
        id:1,
        Name:"Smart TV",
        price:"$1026",
        image:image,
        cat:"tv",
        type:"new"
    },
    {
        id:2,
        Name:"Laptop",
        price:"$830",
        image:image2,
        cat:"laptop",
        type:"new"
    },
    {
        id:3,
        Name:"SmartWatch",
        price:"$132",
        image:image3,
        cat:"watch",
        type:"new"
    },
    {
        id:4,
        Name:"SmartWatch",
        price:"$132",
        image:image3,
        cat:"watch",
        type:"new"
    },
    {
        id:5,
        Name:"EarPhone",
        price:"$102",
        image:image7,
        cat:"electronics",
        type:"featured"
    },
    {
        id:6,
        Name:"Music Player",
        price:"$96",
        image:image5,
        cat:"electronics",
        type:"featured"
    },
    {
        id:7,
        Name:"HeadPhone",
        price:"$96",
        image:image8,
        cat:"headphone",
        type:"featured"
    },
    {
        id:8,
        Name:"SmartPhone",
        price:"$1200",
        image:image6,
        cat:"phone",
        type:"top"
    },
    {
        id:9,
        Name:"HeadPhone",
        price:"$343",
        image:image8,
        cat:"headphone",
        type:"top"
    },
    {
        id:10,
        Name:"Music Player",
        price:"$544",
        image:image4,
        cat:"speaker",
        type:"top"
    },
    {
        id:11,
        Name:"Music Player",
        price:"$144",
        image:image11,
        cat:"speaker",
        type:"top"
    },
    {
    id:12,
    Name:"Planshet",
    price:"$96",
    image:image9,
    cat:"phone",
    type:"featured"
},

]

export default HomeProducts;